import { render, staticRenderFns } from "./KeywordRule.vue?vue&type=template&id=68da7461&scoped=true&"
import script from "./KeywordRule.vue?vue&type=script&lang=js&"
export * from "./KeywordRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da7461",
  null
  
)

export default component.exports